{
  "familyId": "STU-TABEL",
  "questions": [
    {
      "id": "STU-TABEL-001",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "table_reading",
      "question": "Bekijk de tabel. Hoeveel leerlingen zitten er in groep 7?",
      "context": null,
      "options": ["28", "25", "30", "22"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
        "rows": [
          ["Groep 6", "25", "12", "13"],
          ["Groep 7", "28", "15", "13"],
          ["Groep 8", "30", "14", "16"]
        ],
        "selectType": "row",
        "correctSelection": 1,
        "questionTarget": "Groep 7 - Aantal leerlingen"
      },
      "stimulusAids": [
        {
          "type": "table_reading",
          "data": {
            "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
            "rows": [
              ["Groep 6", "25", "12", "13"],
              ["Groep 7", "28", "15", "13"],
              ["Groep 8", "30", "14", "16"]
            ],
            "label": "Leerlingenaantal per groep"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tabellen lezen",
            "content": "Stap 1: zoek de rij voor 'Groep 7'. Stap 2: kijk in de kolom 'Aantal leerlingen'. Waar de rij en kolom elkaar kruisen, vind je het antwoord: 28.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_basic",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Strategie: zoek het kruispunt van de juiste rij en kolom. Stap 1: Zoek de rij 'Groep 7' (tweede rij). Stap 2: Zoek de kolom 'Aantal leerlingen' (tweede kolom). Stap 3: Waar rij en kolom elkaar kruisen, staat het antwoord: 28.",
        "distractorExplanations": {
          "0": "Correct! In groep 7 zitten 28 leerlingen.",
          "1": "Veelgemaakte fout: de verkeerde rij aflezen. 25 is het aantal leerlingen in groep 6, niet in groep 7. Let op dat je de juiste rij kiest.",
          "2": "Veelgemaakte fout: de verkeerde rij aflezen. 30 is het aantal leerlingen in groep 8, niet in groep 7. Let op dat je de juiste rij kiest.",
          "3": "Veelgemaakte fout: een getal kiezen dat niet in de tabel staat. 22 komt niet voor in de tabel. Het juiste antwoord voor groep 7 is 28."
        }
      }
    },
    {
      "id": "STU-TABEL-002",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "schedule_reading",
      "question": "Bekijk het rooster. Welk vak heeft groep 7 op dinsdag om 10:00 uur?",
      "context": null,
      "options": ["Rekenen", "Taal", "Gym", "Aardrijkskunde"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Tijd", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag"],
        "rows": [
          ["09:00", "Taal", "Aardrijkskunde", "Rekenen", "Taal", "Rekenen"],
          ["10:00", "Rekenen", "Rekenen", "Taal", "Gym", "Aardrijkskunde"],
          ["11:00", "Gym", "Taal", "Muziek", "Rekenen", "Taal"]
        ],
        "correctCell": {"row": 1, "col": 2}
      },
      "stimulusAids": [
        {
          "type": "table_reading",
          "data": {
            "headers": ["Tijd", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag"],
            "rows": [
              ["09:00", "Taal", "Aardrijkskunde", "Rekenen", "Taal", "Rekenen"],
              ["10:00", "Rekenen", "Rekenen", "Taal", "Gym", "Aardrijkskunde"],
              ["11:00", "Gym", "Taal", "Muziek", "Rekenen", "Taal"]
            ],
            "label": "Weekrooster groep 7"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Roosters lezen",
            "content": "Stap 1: zoek de dag 'Dinsdag' bovenaan. Stap 2: zoek het tijdstip '10:00' aan de linkerkant. Stap 3: kijk waar de kolom en rij elkaar kruisen: Rekenen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schedule_reading_basic",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: zoek het kruispunt van dag (kolom) en tijdstip (rij). Stap 1: Zoek 'Dinsdag' bovenaan het rooster (derde kolom). Stap 2: Zoek '10:00' aan de linkerkant (tweede rij). Stap 3: Waar kolom en rij elkaar kruisen, staat het vak: Rekenen.",
        "distractorExplanations": {
          "0": "Correct! Op dinsdag om 10:00 uur is het vak Rekenen.",
          "1": "Veelgemaakte fout: het juiste tijdstip maar de verkeerde dag/rij aflezen. Taal staat op dinsdag om 11:00 uur, niet om 10:00 uur. Let op dat je de juiste rij (10:00) kiest.",
          "2": "Veelgemaakte fout: de verkeerde dag en het verkeerde tijdstip aflezen. Gym staat op maandag om 11:00 uur, niet op dinsdag om 10:00 uur.",
          "3": "Veelgemaakte fout: het juiste dag maar het verkeerde tijdstip aflezen. Aardrijkskunde staat op dinsdag om 09:00 uur, niet om 10:00 uur."
        }
      }
    },
    {
      "id": "STU-TABEL-003",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "table_reading",
      "question": "Bekijk de tabel. Hoeveel meisjes zitten er in groep 8?",
      "context": null,
      "options": ["16", "14", "30", "13"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
        "rows": [
          ["Groep 6", "25", "12", "13"],
          ["Groep 7", "28", "15", "13"],
          ["Groep 8", "30", "14", "16"]
        ],
        "selectType": "cell",
        "correctSelection": 11,
        "questionTarget": "Groep 8 - Aantal meisjes"
      },
      "stimulusAids": [
        {
          "type": "table_reading",
          "data": {
            "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
            "rows": [
              ["Groep 6", "25", "12", "13"],
              ["Groep 7", "28", "15", "13"],
              ["Groep 8", "30", "14", "16"]
            ],
            "label": "Leerlingenaantal per groep"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tabellen lezen",
            "content": "Stap 1: zoek de rij voor 'Groep 8'. Stap 2: kijk in de kolom 'Aantal meisjes'. Let op: 14 is het aantal jongens, niet meisjes. Het juiste antwoord is 16.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_basic",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Strategie: zoek het kruispunt van de juiste rij en kolom — let goed op welke kolom je afleest. Stap 1: Zoek de rij 'Groep 8' (derde rij). Stap 2: Zoek de kolom 'Aantal meisjes' (vierde kolom). Stap 3: Waar rij en kolom kruisen: 16. Let op: de kolom ernaast ('Aantal jongens') geeft 14 — dat is een veelgemaakte fout.",
        "distractorExplanations": {
          "0": "Correct! In groep 8 zitten 16 meisjes.",
          "1": "Veelgemaakte fout: de verkeerde kolom aflezen. 14 is het aantal jongens in groep 8, niet het aantal meisjes. De kolom 'Aantal meisjes' staat rechts van 'Aantal jongens'.",
          "2": "Veelgemaakte fout: het totaal verwarren met een deelgroep. 30 is het totale aantal leerlingen in groep 8 (jongens + meisjes samen), niet alleen de meisjes.",
          "3": "Veelgemaakte fout: de verkeerde rij aflezen. 13 is het aantal meisjes in groep 6 en groep 7, niet in groep 8. Let op dat je de rij 'Groep 8' kiest."
        }
      }
    },
    {
      "id": "STU-TABEL-004",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "table_reading",
      "question": "Bekijk de tabel. In welke groep zitten de meeste jongens?",
      "context": null,
      "options": ["Groep 7", "Groep 6", "Groep 8", "In alle groepen evenveel"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
        "rows": [
          ["Groep 6", "25", "12", "13"],
          ["Groep 7", "28", "15", "13"],
          ["Groep 8", "30", "14", "16"]
        ],
        "selectType": "column",
        "correctSelection": 2,
        "questionTarget": "Kolom Aantal jongens - hoogste waarde"
      },
      "stimulusAids": [
        {
          "type": "table_reading",
          "data": {
            "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
            "rows": [
              ["Groep 6", "25", "12", "13"],
              ["Groep 7", "28", "15", "13"],
              ["Groep 8", "30", "14", "16"]
            ],
            "label": "Leerlingenaantal per groep"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tabel vergelijken",
            "content": "Kijk in de kolom 'Aantal jongens': Groep 6 = 12, Groep 7 = 15, Groep 8 = 14. Het hoogste getal is 15, dus in Groep 7 zitten de meeste jongens.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_compare",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Strategie: vergelijk alle waarden in dezelfde kolom en zoek de hoogste. Stap 1: Lees de kolom 'Aantal jongens' af: Groep 6 = 12, Groep 7 = 15, Groep 8 = 14. Stap 2: Vergelijk: 12 < 14 < 15. Stap 3: Het hoogste getal is 15 → Groep 7 heeft de meeste jongens.",
        "distractorExplanations": {
          "0": "Correct! Groep 7 heeft 15 jongens — meer dan groep 6 (12) en groep 8 (14).",
          "1": "Veelgemaakte fout: niet alle waarden vergelijken. Groep 6 heeft 12 jongens. Groep 7 heeft er meer: 15. Vergelijk altijd alle rijen.",
          "2": "Veelgemaakte fout: de groep met de meeste leerlingen kiezen. Groep 8 heeft de meeste leerlingen (30), maar niet de meeste jongens (14). Groep 7 heeft 15 jongens.",
          "3": "Veelgemaakte fout: aannemen dat de aantallen gelijk zijn zonder te controleren. De aantallen zijn 12, 15 en 14 — niet gelijk. Groep 7 heeft de meeste jongens (15)."
        }
      }
    },
    {
      "id": "STU-TABEL-005",
      "familyId": "STU-TABEL",
      "module": "Studievaardig",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "schemas",
      "subSkill": "schema_tabel",
      "questionType": "table_reading",
      "question": "Bekijk de tabel. Hoeveel leerlingen zitten er in totaal in alle drie de groepen?",
      "context": null,
      "options": ["83", "53", "28", "90"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
        "rows": [
          ["Groep 6", "25", "12", "13"],
          ["Groep 7", "28", "15", "13"],
          ["Groep 8", "30", "14", "16"]
        ],
        "selectType": "column",
        "correctSelection": 1,
        "questionTarget": "Kolom Aantal leerlingen - totaal"
      },
      "stimulusAids": [
        {
          "type": "table_reading",
          "data": {
            "headers": ["Groep", "Aantal leerlingen", "Aantal jongens", "Aantal meisjes"],
            "rows": [
              ["Groep 6", "25", "12", "13"],
              ["Groep 7", "28", "15", "13"],
              ["Groep 8", "30", "14", "16"]
            ],
            "label": "Leerlingenaantal per groep"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tabel optellen",
            "content": "Tel de waarden in de kolom 'Aantal leerlingen' bij elkaar op: 25 + 28 + 30 = 83. Tip: 25 + 28 = 53, dan 53 + 30 = 83.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "table_reading_sum",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Strategie: tel alle waarden in de gevraagde kolom bij elkaar op. Stap 1: Lees de kolom 'Aantal leerlingen' af: 25, 28, 30. Stap 2: Reken stap voor stap: 25 + 28 = 53. Stap 3: 53 + 30 = 83. Er zitten in totaal 83 leerlingen in de drie groepen.",
        "distractorExplanations": {
          "0": "Correct! 25 + 28 + 30 = 83 leerlingen in totaal.",
          "1": "Veelgemaakte fout: niet alle rijen optellen. 53 = 25 + 28 — je bent vergeten groep 8 (30) erbij op te tellen. 53 + 30 = 83.",
          "2": "Veelgemaakte fout: maar één waarde aflezen in plaats van optellen. 28 is alleen het aantal leerlingen in groep 7. Je moet alle drie de groepen optellen: 25 + 28 + 30 = 83.",
          "3": "Veelgemaakte fout: verkeerd rekenen. 90 is te veel. De juiste berekening is 25 + 28 + 30 = 83, niet 90."
        }
      }
    }
  ]
}
